import VoucherInputField from "./index";

export default function VoucherInputFieldExamples() {
  return (
    <VoucherInputField
      handleInputChange={() => console.log("voucher input changed")}
      setError={function (): void {
        throw new Error("Function not implemented.");
      }}
      setLocalErrorMessage={function (): void {
        throw new Error("Function not implemented.");
      }}
      error={false}
      localErrorMessage={""}
    />
  );
}
